import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWrapper from './ModalWrapper';
import ModalCloseButton from './ModalCloseButton';
import Button from './Button';

/**
 * 공통 확인 모달 — window.confirm 대체용. 모노톤 브랜드 스타일.
 *
 * Props:
 *   open: boolean
 *   onClose: () => void           — 취소 / X / 백드롭 클릭
 *   onConfirm: () => void         — 확인 클릭 (호출 후 자동 close)
 *   title: string                 — 헤더 (default: '확인')
 *   message: string               — 본문 (whitespace-pre-line 지원)
 *   confirmLabel: string          — 확인 버튼 (default: '확인')
 *   cancelLabel: string           — 취소 버튼 (default: '취소')
 */
export default function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
}) {
  const { t } = useTranslation();
  if (!open) return null;
  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };
  return (
    <ModalWrapper onClose={onClose} padding="p-5" gap="gap-4" maxWidth="max-w-[460px]" className="relative">
      <div className="absolute top-5 right-5">
        <ModalCloseButton onClick={onClose} />
      </div>
      <div className="flex flex-col gap-3 pt-2">
        <h2 className="text-lg font-bold text-mono-900">{title || t('common.confirm')}</h2>
        {message && (
          <p className="text-sm text-mono-600 leading-relaxed break-keep whitespace-pre-line">{message}</p>
        )}
      </div>
      <div className="flex gap-2">
        <Button level="level3" fullWidth onClick={onClose}>{cancelLabel || t('common.cancel')}</Button>
        <Button level="dark" fullWidth onClick={handleConfirm}>{confirmLabel || t('common.confirm')}</Button>
      </div>
    </ModalWrapper>
  );
}
